/**
 * Renders the search of the document viewer
 */
import React from "react";
import ReactDOM from "react-dom";
import $ from "jquery";

export default class extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      terms: props.initialSearchTerms,
      focus: false,
      setCursor: false
    };
  }

  componentDidUpdate() {
    if(this.state.setCursor) {
      this.focusTextCursor();
      this.setState({ setCursor: false });
    }
  }

  /**
   * Sets cursor to end of input
   */
  focusTextCursor() {
    var input = ReactDOM.findDOMNode(this.refs.input);
    input.focus();
  }

  /**
   * Is fired when the search terms have changed
   */
  handleInputChange(event) {
    this.clearChangeTimer();

    this.setState({ terms: event.target.value });

    if(this.props.onSearchChange) this.props.onSearchChange();

    this.changeTimer = window.setTimeout(
      this.handleChangeTimer.bind(this),
      500
    );
  }

  /**
   * Checks for <return>
   */
  handleKeyPress(event) {
    if(event.charCode == 13) {
      this.clearChangeTimer();
      this.search();
    }
  }

  /**
   * Is fired when change is coming
   */
  handleChangeTimer() {
    this.clearChangeTimer();
    this.search();
  }

  search() {
    if(this.hasTerms()) {
      this.props.onSearch(this.state.terms);
    } else {
      this.props.onReset();
    }
  }

  /**
   * Catches click event
   */
  handleClick(event) {
    event.preventDefault();
    this.setState({ focus: true, setCursor: true });
  }

  /**
   * Catches reset click
   */
  handleResetClick(event) {
    event.preventDefault();
    this.setState({ focus: false, terms: "" });
    this.props.onReset();
  }

  /**
   * Is fired when input receives focus
   */
  handleFocus(event) {
    this.setState({ focus: true });
  }

  /**
   * Is fired when input loses focus
   */
  handleBlur(event) {
    this.setState({ focus: false });
  }

  /**
   * Removes change timer
   */
  clearChangeTimer() {
    if(this.changeTimer) {
      window.clearTimeout(this.changeTimer);
      this.changeTimer = null;
    }
  }

  hasTerms() {
    return $.trim(this.state.terms) != "";
  }

  render() {
    var input,
        reset,
        className = "document-viewer-search";

    if(this.hasTerms() && !this.state.focus) {
      input = (
        <div
          onClick={this.handleClick.bind(this)}
          className="document-viewer-search-terms">
          {this.state.terms}
        </div>
      );
    } else {
      let inputClassName = "document-viewer-search-input";

      if(this.hasTerms()) {
        inputClassName += " document-viewer-search-input--locked";
      }

      input = (
        <input
          className={inputClassName}
          type="text"
          ref="input"
          placeholder="Search"
          value={this.state.terms}
          onKeyPress={this.handleKeyPress.bind(this)}
          onFocus={this.handleFocus.bind(this)}
          onBlur={this.handleBlur.bind(this)}
          onChange={this.handleInputChange.bind(this)} />);
    }

    if(this.hasTerms()) {
      className += " document-viewer-search--locked";

      reset = (
        <div
          className="document-viewer-search-reset"
          onClick={this.handleResetClick.bind(this)} />
      );
    }

    if(this.props.loading) {
      className += " document-viewer-search--loading";
    }

    return (
      <div className={className} onClick={this.handleClick.bind(this)}>
        {input}
        {reset}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/portal/documents/search.jsx